import React, { useState } from 'react'
import moment from 'moment'
import { TableRow, TableCell, Box, Typography, Button } from '@mui/material'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { grey, orange, green } from '@mui/material/colors'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled'
import CancelIcon from '@mui/icons-material/Cancel'
import {
  PENDING_STATUS,
  APPROVED_STATUS,
  DECLINED_STATUS,
} from '../../constant/staff-benefit-status'
import styled from 'styled-components'
import { DisplayImageDialog } from '../shared/component/DisplayImageDialog'

const StyledButton = styled(Button)`
  && {
    color: #0c479d;
    text-decoration: underline;
    :hover {
      color: #000;
    }
  }
`

const useStyles = makeStyles((theme) => ({
  expired: { backgroundColor: grey[100], color: grey[600] },
  statusText: {
    marginLeft: theme.spacing(1),
  },
}))

export const ClaimRow = (props) => {
  const classes = useStyles()
  const { row } = props

  const { staffBenefit } = row

  const renderDiscount = () => {
    switch (staffBenefit.type) {
      case 'Amount':
        return `RM${staffBenefit.discountAmount} discount`
      case 'Percentage':
        return `${+(Math.round(staffBenefit.discountPercentage * 100 + 'e+2') + 'e-2')}% discount`
      case 'Gift':
        return `Free Gift: ${staffBenefit.freeGift}`
      default:
        break
    }
  }

  const renderStatus = () => {
    switch (row.status) {
      case PENDING_STATUS:
        return (
          <Box display='flex' alignItems='center'>
            <PlayCircleFilledIcon style={{ fill: orange[700] }} />
            <Typography
              variant='body2'
              className={classes.statusText}
              style={{ color: orange[700] }}
            >
              {row.status}
            </Typography>
          </Box>
        )
      case APPROVED_STATUS:
        return (
          <Box display='flex' alignItems='center'>
            <CheckCircleIcon style={{ fill: green[500] }} />
            <Typography
              variant='body2'
              className={classes.statusText}
              style={{ color: green[500] }}
            >
              {row.status}
            </Typography>
          </Box>
        )
      case DECLINED_STATUS:
        return (
          <Box display='flex' alignItems='center'>
            <CancelIcon color='error' />
            <Typography variant='body2' className={classes.statusText} style={{ color: 'error' }}>
              {row.status}
            </Typography>
          </Box>
        )
      default:
        break
    }
  }

  //handle close display image dialog
  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false)
  }

  const handleDialog = () => {
    setOpen(!open)
  }

  const uploadPath = row?.invoiceImg?.uploadPath

  return (
    <React.Fragment>
      <TableRow
        className={clsx({
          [classes.expired]:
            staffBenefit.endDate && moment(staffBenefit.endDate).isBefore(moment()),
        })}
      >
        <TableCell align='left'>
          {row.htgCompany}
          {row.processedId}
        </TableCell>
        <TableCell align='left'>{staffBenefit.staffBenefitCode}</TableCell>
        <TableCell align='left'>{staffBenefit.name}</TableCell>
        <TableCell align='left'>{renderDiscount()}</TableCell>
        <TableCell align='left'>{row.regionalState}</TableCell>
        <TableCell align='left'>{row.quantity}</TableCell>
        <TableCell align='left'>{row.carPlate}</TableCell>
        <TableCell align='left'>{row.carModel}</TableCell>
        <TableCell align='left'>{row.supplier}</TableCell>
        <TableCell align='right'>
          <StyledButton onClick={handleDialog} size='small'>
            show image
          </StyledButton>
        </TableCell>
        <TableCell align='left'>{renderStatus()}</TableCell>
        <TableCell align='left'>
          {moment(staffBenefit.startDate).format('D/M/YYYY')} -{' '}
          {moment(staffBenefit.endDate).format('D/M/YYYY')}
        </TableCell>
      </TableRow>
      <DisplayImageDialog handleClose={handleClose} open={open} uploadPath={uploadPath} />
    </React.Fragment>
  )
}
